import React from 'react'
import { CssBaseline } from '@mui/material'
import { css, ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { theme } from './theme'
import { GlobalStyles } from '@mui/material'
import { ibmPlexSansCssVariable } from '@/styles/fonts'

const globalStyles = css`
  body {
    margin: 0;
    font-family:
      var(${ibmPlexSansCssVariable}),
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      'Roboto',
      'Oxygen',
      'Ubuntu',
      'Cantarell',
      'Fira Sans',
      'Droid Sans',
      'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }
`

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <GlobalStyles styles={globalStyles} />
    {children}
  </MuiThemeProvider>
)
